import React, { FC } from 'react';
import styles from './BasicSettingsWrap.module.scss';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  getContacts,
  getSocialNetworkTypes,
  updateMainObject,
} from '../../../../../redux/reducers/mainObjectSlice';
import {
  BasicSettingsType,
  MainObject,
} from '../../../../../redux/types/mainObjectTypes';
import {
  AddressType,
  ButtonType,
  MessageTypes,
  ModalWindowTypes,
} from '../../../../../utils/@globalTypes';
import { CopyIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import { RoutesList } from '../../../../../App';
import {
  setMessage,
  setModalWindowData,
} from '../../../../../redux/reducers/pageSlice';
import { API_HOST } from '../../../../../utils/config';
import { TariffsSelectors } from '../../../../../redux/reducers/tariffsSlice';
import { TarifTypes } from '../../../../../redux/types/@types';
import useBasicValidationSchema from './../basicValidationSchema';
import BasicSettingsForm from '../BasicSettingsForm';
import { getContentForBackend } from '../../../../../utils/editorsUtil';

type BasicSettingsProps = {
  pageId: string;
  currentObject: MainObject | null;
};

const BasicSettingsWrap: FC<BasicSettingsProps> = ({
  pageId,
  currentObject,
}) => {
  const dispatch = useDispatch();
  const bookingLink = `https://${
    API_HOST.includes('dev') ? 'dev.' : API_HOST.includes('stage') ? 'stage.' : ''
  }client.vitaem.app/${pageId}`;

  const validationSchema = useBasicValidationSchema();

  const initialValues: BasicSettingsType = {
    objectName: currentObject?.name || '',
    objectType: currentObject?.object_type.id.toString() || '',
    country: currentObject?.country || '',
    region: currentObject?.full_address?.region || '',
    locality: currentObject?.full_address?.locality || '',
    address: currentObject?.full_address?.address || '',
    bookingImage: currentObject?.booking_photo || null,
    newBookingImage: [],
    homeImage: currentObject?.photo || null,
    newHomeImage: [],
    rulesPdf: currentObject?.rules || null,
    textRules: currentObject?.text_rules || "",
  };

  const currentTarif = useSelector(TariffsSelectors.getCurrentTarif);

  const copyLinkBtn = () => {
    navigator.clipboard.writeText(bookingLink);
    dispatch(
      setMessage({
        status: MessageTypes.POSITIVE,
        code: 200,
        message: 'Скопировано в буфер обмена',
      }),
    );
  };

  const handlerWindowContacts = () => {
    if (currentObject) {
      dispatch(getContacts(currentObject.id));
      dispatch(getSocialNetworkTypes({}));
      dispatch(
        setModalWindowData({ type: ModalWindowTypes.CREATE_OBJECT_CONTACTS }),
      );
    }
  };

  return (
    <Formik<BasicSettingsType>
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnBlur={false}
      validateOnChange={false}
      validateOnMount={false}
      enableReinitialize={true}
      onSubmit={(values) => {
        if (!!currentObject) {
          const formData = new FormData();

          const {
            object_type,
            name,
            country: objCountry,
            full_address            
          } = currentObject;

          object_type.id !== +values.objectType &&
            formData.append('object_type', values.objectType);
          name !== values.objectName &&
            formData.append('name', values.objectName);
          objCountry !== values.country &&
            formData.append('country', values.country);

          if (
            values.newHomeImage.length > 0 &&
            values.newHomeImage[0].hasOwnProperty('file')
          ) {
            values.newHomeImage[0].file instanceof Blob &&
              formData.append('photo', values.newHomeImage[0].file as Blob);
          }
          values.newBookingImage.length > 0 &&
            values.newBookingImage[0].file &&
            values.newBookingImage[0].file instanceof Blob &&
            formData.append(
              'booking_photo',
              values.newBookingImage[0].file as Blob,
            );

          if (
            (full_address &&
              (full_address.region !== values.region ||
                full_address.locality !== values.locality ||
                full_address.address !== values.address)) ||
            !full_address
          ) {
            const newFullAddress: AddressType = {
              region: values.region,
              locality: values.locality,
              address: values.address,
            };
            formData.append('full_address', JSON.stringify(newFullAddress));
          }
          if (values.rulesPdf !== currentObject.rules) {
            formData.append('rules', values.rulesPdf as Blob);
          }
          const hasTextContent = getContentForBackend(values.textRules)
          // console.log(hasTextContent)

          if(hasTextContent !== currentObject.text_rules) {
            formData.append("text_rules", hasTextContent)
          }
          
          dispatch(
            updateMainObject({
              data: formData,
              id: pageId,
            }),
          );
        }
      }}
    >
      {(formik) => (
        <Form>
          <>
            <BasicSettingsForm formik={formik} currentObject={currentObject} />
            <div className={styles.btnsContainer}>
              <div className={styles.btnLeft}>
                <Button
                  title="Добавить контактные данные"
                  type={ButtonType.SECONDARY_SMALL}
                  onClick={handlerWindowContacts}
                  wrapperClassName={styles.openBookingBtnWrap}
                  className={styles.openBookingBtn}
                />
                {currentTarif !== TarifTypes.FREE && (
                  <div className={styles.btnsWrapBooking}>
                    <Button
                      title="Открыть страницу бронирования"
                      type={ButtonType.SECONDARY_SMALL}
                      path={bookingLink}
                      targetBlank
                      wrapperClassName={styles.openBookingBtnWrap}
                      className={styles.openBookingBtn}
                    />
                    <Button
                      title={<CopyIcon />}
                      className={styles.copyBtn}
                      type={ButtonType.SMALL}
                      onClick={copyLinkBtn}
                    />
                  </div>
                )}
              </div>
              <div className={styles.btnsWrapMain}>
                <Button
                  title="Сохранить"
                  actionType="submit"
                  type={ButtonType.PRIMARY_SMALL}
                  disabled={!formik.isValid || !formik.dirty}
                  className={styles.mainBtn}
                />
                <Button
                  title="Отмена"
                  type={ButtonType.SECONDARY_SMALL}
                  path={RoutesList.objectManagement.fullPath}
                  className={styles.mainBtn}
                />
              </div>
            </div>
          </>
        </Form>
      )}
    </Formik>
  );
};

export default BasicSettingsWrap;
